import e from"react";const r=({children:r,className:a=""})=>e.createElement("div",{className:`row ${a}`},r);export{r as Row};
//# sourceMappingURL=Row.js.map
